import { FlagComponent } from "@type/index";

export enum FLAG_TYPE {
  PRICE = "price",
  PRODUCT = "product"
}

export enum FLAG_COLOR_CONFIG {
  RED = "promotional",
  GREY = "placeholder",
  BLACK = "standard"
}

export type flagColorType =
  | "promotional"
  | "placeholder"
  | "primary-dark"
  | "secondary"
  | undefined;

type flagConfigObj = {
  flag_color: flagColorType;
};

type newObjType = {
  price_flag?: [
    {
      flag: string;
      color: flagColorType;
    }
  ];
  product_flag?: {
    flag: string;
    color: flagColorType;
  };
};

/**
 * refer to "All about display flags" excel (sheet 1-Type) Group0 and Group 1
 * show price flags priority
 * ex: flag code: priority
 */
const priceFlagConfig: { [key: string]: flagConfigObj } = {
  specialPrice: {
    flag_color: FLAG_COLOR_CONFIG.RED
  },
  multibuy: {
    flag_color: FLAG_COLOR_CONFIG.RED
  },
  appmemberLimited: {
    flag_color: FLAG_COLOR_CONFIG.RED
  },
  onlineLimited: {
    flag_color: FLAG_COLOR_CONFIG.RED
  },
  limitedOffer: {
    flag_color: FLAG_COLOR_CONFIG.RED
  },
  newPrice: {
    flag_color: FLAG_COLOR_CONFIG.GREY
  },
  discount: {
    flag_color: FLAG_COLOR_CONFIG.RED
  },
  colorSizeLimitedPrice: {
    flag_color: FLAG_COLOR_CONFIG.RED
  },
  bundledOffer: {
    flag_color: FLAG_COLOR_CONFIG.RED
  }
};

export const handleFlagsSort = (
  priceFlag: { promotionText: string; priceFlag: Array<FlagComponent> },
  productFlag: Array<FlagComponent>,
  t: any
) => {
  const newPriceFlag = JSON.parse(JSON.stringify(priceFlag));
  const newProductFlag = JSON.parse(JSON.stringify(productFlag));
  const obj: newObjType = {
    price_flag: undefined,
    product_flag: undefined
  };
  if (newPriceFlag.priceFlag.length > 0) {
    obj.price_flag = newPriceFlag.priceFlag.map((p: FlagComponent) => {
      const name =
        p.nameWording && p.nameWording?.flagWithTime
          ? t(p.nameWording.flagWithTime, {
              date: p.nameWording.substitutions?.date,
              month: p.nameWording.substitutions?.month,
              flagName: p.nameWording.substitutions?.flagName,
              startDate: p.nameWording.substitutions?.startDate
            })
          : p.name;
      const priceData = {
        flag:
          priceFlag.promotionText && p.code === "specialPrice"
            ? priceFlag.promotionText
            : name,
        color: priceFlagConfig[p.code]?.flag_color || FLAG_COLOR_CONFIG.RED
      };
      return priceData;
    });
  } else if (newProductFlag.length > 0) {
    obj.product_flag = {
      flag: newProductFlag
        .map((p: FlagComponent) => {
          const name =
            p.nameWording && p.nameWording?.flagWithTime
              ? t(p.nameWording.flagWithTime, {
                  date: p.nameWording.substitutions?.date,
                  month: p.nameWording.substitutions?.month,
                  flagName: p.nameWording.substitutions?.flagName,
                  startDate: p.nameWording.substitutions?.startDate
                })
              : p.name;
          return name;
        })
        .join(", "),
      color: "placeholder"
    };
  }
  return obj;
};
